import ListeSection from  '@/views/parametres/configs/param-fiche-medical/liste-sections'
import ListeSectionChamps from  '@/views/parametres/configs/param-fiche-medical/liste-sections-champs'
import ListeFicheConsultation from  '@/views/parametres/configs/param-fiche-medical/liste-fiche-consultation'

export default {
    name: 'param-fiche-medical',
    components: {
        ListeSection, ListeFicheConsultation, ListeSectionChamps
    },
    props: [],
    data() {
        return {
            fields: [
				'prestations',  { key: 'actions', label: 'Action.s' }
			],
			filter_consultation: "",
			perPage: 40,
			currentPage: 1,

            consul_loading: true,
            consul_empty: true,

            selected_consultation: {},
            selected_fiche: {},
            selected_section: {},
            curr_page: "liste_consultation",
            toggler: 0,
            is_config: false,
            liste_autre_consultations: [],
            info_user: {}
        }
    },

    computed: {
        liste_all_type_consultations() {
            return this.$store.getters["liste_all_type_consultations"];
        },

        consult_gen_rows() {
            return this.liste_all_type_consultations.length;
        },

        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        activeRole() {
            return this.$store.getters['activeRole'];
        },
    },

    mounted() {
        this.refreshConsultation()

        this.userInfoSetter()
    },

    methods: {
        userInfoSetter() {
            this.info_user = {
                id: this.userCredentials.id,
                nom: this.userCredentials.name,
                titre: this.userCredentials.titre
            }
        },

        refreshConsultation() {
			this.consul_loading = true

			this.$store.dispatch("getListeTypeConsultations").then(() => {
                this.consul_loading = false
                if(this.liste_all_type_consultations.length > 0) {
                    this.consul_empty = false
                } else {
                    this.consul_empty = true
                }
            });
		},

        configurer(data) {
            this.toggler = (this.toggler == 0)?1:0
            this.liste_autre_consultations = []
            this.selected_consultation = data
            
            this.liste_all_type_consultations.forEach(consultation => {
                if (consultation.id != this.selected_consultation.id) {
                    this.liste_autre_consultations.push(consultation)
                }
            });

            this.curr_page = 'liste_fiche_consultation'
        },

        backToHome() {
            this.curr_page = 'liste_consultation'
        },

        goTo(prev_page) {
            this.curr_page = prev_page
        },

        setPageToGo(info) {
            this.selected_fiche = info.fiche_data
            this.goTo(info.go_to_page)
        },

        setSelectedSection(data) {
            this.selected_section = data
        }
    }
}